import axios from 'axios';
import { DefaultCourse } from '../courses/course';
import { Image } from './image';

export class ImageShow {
  public static async getData(id: number): Promise<any> {
    return axios.get(`/api/images/show/${id}`);
  }

  public static async deleteData(id: number): Promise<any> {
    return axios.delete(`/api/images/${id}`);
  }

  public static async saveData(formData: FormData): Promise<any> {
    return axios.post('/api/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  public static parseResponse(response: any): Image {  
    const image = {} as Image;
    
    image.course_id = Number(response.data.course_id);
  
    return image;
  }
}